import { render, staticRenderFns } from "./DA.vue?vue&type=template&id=060dd718&scoped=true&"
import script from "./DA.vue?vue&type=script&lang=js&"
export * from "./DA.vue?vue&type=script&lang=js&"
import style0 from "./DA.vue?vue&type=style&index=0&id=060dd718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060dd718",
  null
  
)

export default component.exports